module.exports = __webpack_public_path__ + "img/envelope.c969693e.svg";